import { Button, DropDownButton } from '@progress/kendo-react-buttons'

import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'

import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from '@progress/kendo-react-layout'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import PesquisarIntervencao from './PesquisarIntervencao'
import PesquisarAcao from './PesquisarAcao'
import PesquisarCandidatura from './PesquisarCandidatura'
import PesquisarMobilizacao from './PesquisarMobilizacao'
import { useAcaoStore } from '../../stores/acao'
import { useCandidaturaStore } from '../../stores/candidatura'
import { useMobilizacaoStore } from '../../stores/mobilizacao'
import { useIntervencaoStore } from '../../stores/intervencao'
import { _export, _exportPdf, b64toBlob, entidadeUser, exportPDFWithMethod, exportToExcelWithTabsIntervencao, get, handleDownload, hasPermission, post, setAcaoSelected, setCandidaturaAcaoSelected, setCandidaturaSelected, setCoordenadasPoligono, setIntervencaoSelected, setMobilizacaoSelected, updateColumnsGrid } from '../../services/utils'
import { AUTH_LOCALSTORAGE, CONSULTAR_ACAO, CONSULTAR_CANDIDATURA, CONSULTAR_INTERVENCAO, CONSULTAR_INTERVENCAO_TO_EXPORT, CONSULTAR_MOBILIZACAO, GET_ACAO_CANDIDATURA_TO_EXPORT, GET_ACAO_COMPONENTES_TO_EXPORT, GET_ACAO_EXECUCAO_RESUMO_TO_EXPORT, GET_ACAO_EXECUCAO_TO_EXPORT, GET_ACAO_FONTE_FINANCIAMENTO_TO_EXPORT, GET_ACAO_MOBILIZACAO_BY_MOBILIZACAO_ID, GET_ACAO_MOBILIZACAO_TO_EXPORT, GET_ACAO_TO_EXPORT, GET_ASSOCIACOES_ACAO_INTERVENCAO_TO_EXPORT, GET_ASSOCIACOES_INTERVENCAO_TO_EXPORT, GET_CANDIDATURA_ACAO_TO_EXPORT, GET_CANDIDATURA_TO_EXPORT, GET_DOCUMENTO, GET_DOCUMENTO_BY_ACAO, GET_ENTIDADES_ASSOCIADAS_ACAO_TO_EXPORT, GET_ENTIDADES_ASSOCIADAS_INTERVENCAO_TO_EXPORT, GET_EXECUCAO_ACAO_BY_ID_ACAO, GET_INT_ACAO_SHAPEFILE, GET_INT_FONTES_FINANCIAMENTO_INTERVENCOES_TO_EXPORT, GET_INT_INDICADOR_BY_IDS_INTERVENCOES_TO_EXPORT, GET_INT_INTERVENCOES_SHAPEFILE, GET_INT_MOBILIZACAO_SHAPEFILE, GET_INT_PLANEAMENTO_BY_IDS_INTERVENCOES_TO_EXPORT, GET_LIST_RESULTS_ACAO_INTERVENCAO, GET_LIST_RESULTS_EXECUCOES, GET_LIST_RESULTS_INDICADORES, GET_LIST_RESULTS_INDICADORES_ACOES, GET_LIST_RESULTS_INTERVENCAO_ACAO, GET_LIST_RESULTS_INT_ACAO, GET_LIST_RESULTS_INT_CANDIDATURA, GET_LIST_RESULTS_INT_INTERVENCAO, GET_LIST_RESULTS_INT_MOBILIZACAO, GET_LIST_RESULTS_INT_PLANEAMENTO, GET_LIST_RESULTS_MOBILIZACAO_ACAO, GET_LIST_RESULTS_RESUMO_EXECUCOES, GET_MOBILIZACAO_ACAO_TO_EXPORT, GET_MOBILIZACAO_TO_EXPORT, GET_RESUMO_EXECUCAO_ACAO_BY_ID_ACAO, LAYER_INDEX_INT_ACAO, LAYER_INDEX_INT_INTERVENCOES, LAYER_INDEX_INT_MOBILIZACAO, OPERATIONAL_LAYER, PERMISSION_INTERVENCAO_PERFIL_BASICO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, PERMISSION_LISTAR_INTERVENCAO, PERMISSION_LISTAR_INT_ACAO, PERMISSION_LISTAR_INT_CANDIDATURA, PERMISSION_LISTAR_INT_MOBILIZACAO, PESQUISAR_ENTIDADEBYUSER, RECORDS_LIMIT, RELATORIO_MERGE_ACAO, RELATORIO_MERGE_CANDIDATURA, RELATORIO_MERGE_INTERVENCAO, RELATORIO_MERGE_MOBILIZACAO, URL_AJUDA_INTERVENCOES_INTERVENCAO } from '../../utils/constants'
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import SessionStorageService from '../../services/SessionStorageService'
import ResultadoIntervencaoForm from './ResultadoIntervencaoForm'
import ResultadoAcaoForm from './ResultadoAcaoForm'
import MaximizeButton from '../common/MaximizeButton'
import clsx from 'clsx'
import { useCommonStore } from '../../stores/common'
import commonStyles from '../../styles/common/Common.module.scss'
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns'
import { CSVLink } from 'react-csv'
import { format, parse } from 'date-fns'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import ResultadoCandidaturaForm from './ResultadoCandidaturaForm'
import ResultadoMobilizacaoForm from './ResultadoMobilizacaoForm'
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-react-grid'

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  setShowResults: Dispatch<SetStateAction<boolean>>,
  setShowRegistarIntervencao: Dispatch<SetStateAction<boolean>>
  setShowRegistarAcao: Dispatch<SetStateAction<boolean>>
  setShowRegistarCandidatura: Dispatch<SetStateAction<boolean>>
  setShowRegistarMobilizacao: Dispatch<SetStateAction<boolean>>
}

export default function PesquisarIntervencaoTabs({
  onCloseClick,
  setShowRegistarIntervencao,
  setShowRegistarAcao,
  setShowResults,
  setShowRegistarCandidatura,
  setShowRegistarMobilizacao,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelected] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedIntervencoesPai');
    return storedValue ? storedValue : 0;
  });




  const [columnsPrint, setColumnsPrint] = useState<any>();

  const [selectedAcao, setSelectedAcao] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedAcao');
    return storedValue ? storedValue : 0;
  });

  const [selectedIntervencao, setSelectedIntervencao] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedIntervencao');
    return storedValue ? storedValue : 0;
  });

  const [selectedCandidatura, setSelectedCandidatura] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedCandidatura');
    return storedValue ? storedValue : 0;
  });

  const [selectedMobilizacao, setSelectedMobilizacao] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedMobilizacao');
    return storedValue ? storedValue : 0;
  });

  const [newRegistoLabel, setNewRegistoLabel] =
    useState<string>('Nova intervenção')


      const selectIntervencaoResult = useIntervencaoStore((state) => state.selectIntervencaoResult)
  const selectAcaoResult = useAcaoStore((state) => state.selectAcaoResult)
  const selectCandidaturaResult = useCandidaturaStore((state) => state.selectCandidaturaResult)
  const selectMobilizacaoResult = useMobilizacaoStore((state) => state.selectMobilizacaoResult)
  const [seeIntervencaoList, setSeeIntervencaoList] = useState<boolean>(false);
  const [seeAcao, setSeeAcao] = useState<boolean>(false);
  const [seeMobilizacao, setSeeMobilizacao] = useState<boolean>(false);
  const [seeCandidatura, setSeeCandidatura] = useState<boolean>(false);
  const [showResultadoAcao, setShowResultadoAcao] = useState(true)
  const [showResultadoCandidatura, setShowResultadoCandidatura] = useState(true)
  const [showResultadoMobilizacao, setShowResultadoMobilizacao] = useState(true)
  const [documentosacoes, setDocumentosacoes] = useState([])
  const [showExportButtons, setShowExportButtons] = useState(true)
  const consultarIntervencao = async (data: any) => await post<any, any>(`${CONSULTAR_INTERVENCAO}`, data)
  const consultarIntervencaoToExport = async(data: any) => await post<any, any>(`${CONSULTAR_INTERVENCAO_TO_EXPORT}`, data)
  const consultarIntAcaoAssociada = async (data: any) => await post<any, any>(GET_ASSOCIACOES_INTERVENCAO_TO_EXPORT, data);
  const getEntidadesAssociadasToExport = async(data: any) => await post<any, any>(GET_ENTIDADES_ASSOCIADAS_INTERVENCAO_TO_EXPORT, data);
  const getPlaneamentosByIdsIntervencoes = async (data: any) => await post<any,any>(GET_INT_PLANEAMENTO_BY_IDS_INTERVENCOES_TO_EXPORT, data);
  const getIndicadoresByIdsIntervencoes = async (data: any) => await post<any,any> (GET_INT_INDICADOR_BY_IDS_INTERVENCOES_TO_EXPORT, data);
  const getIntFontesFinanciamentosToExport = async (data:any) => await post<any,any>(GET_INT_FONTES_FINANCIAMENTO_INTERVENCOES_TO_EXPORT, data)

  const consultarAcao = async (data: any) => await post<any, any>(`${CONSULTAR_ACAO}`, data)
  const consultarAcaoIntervencaoAssociada = async (data: any) => await post<any, any>(GET_ASSOCIACOES_ACAO_INTERVENCAO_TO_EXPORT, data);
  const getEntidadesAssociadasAcaoToExport = async(data: any) => await post<any, any>(GET_ENTIDADES_ASSOCIADAS_ACAO_TO_EXPORT, data);
  const getMobilizacaoAcaoToExport = async(data: any) => await post<any, any>(GET_MOBILIZACAO_ACAO_TO_EXPORT, data);
  const getExecucoesAcaoToExport = async(data: any) => await post<any, any>(GET_ACAO_EXECUCAO_TO_EXPORT, data);
  const getCandidaturasAcaoToExport = async(data: any) => await post<any, any>(GET_CANDIDATURA_ACAO_TO_EXPORT, data);
  const getAcaoToExport = async(data: any) => await post<any, any>(GET_ACAO_TO_EXPORT, data);
  const getAcaoComponentesToExport = async(data: any) => await post<any, any>(GET_ACAO_COMPONENTES_TO_EXPORT, data);
  const getResumoExecucoesAcaoToExport = async(data: any) => await post<any, any>(GET_ACAO_EXECUCAO_RESUMO_TO_EXPORT, data);
  const getAcaoFonteFinanciamentoToExport = async(data: any) => await post<any, any>(GET_ACAO_FONTE_FINANCIAMENTO_TO_EXPORT, data);
  const getAcaoCandidaturaToExport = async(data: any) => await post<any, any>(GET_ACAO_CANDIDATURA_TO_EXPORT, data);
  const consultarCandidatura = async (data: any) => await post<any, any>(`${CONSULTAR_CANDIDATURA}`, data)
  const getCandidaturaToExport = async (data: any) => await post<any, any>(`${GET_CANDIDATURA_TO_EXPORT}`, data)
  const consultarMobilizacao = async (data: any) => await post<any, any>(`${CONSULTAR_MOBILIZACAO}`, data)
  const getMobilizacaoToExport = async (data: any) => await post<any, any>(`${GET_MOBILIZACAO_TO_EXPORT}`, data)
  const getAcaoMobilizacaoToExport = async (data: any) => await post<any, any>(`${GET_ACAO_MOBILIZACAO_TO_EXPORT}`, data)

  const [showResultadoPesquisaIntervencao, setShowResultadoPesquisaIntervencao] = useState<any>(
    () => {
      const storedValue = SessionStorageService.getItem('showResultadoPesquisaIntervencao');
      return storedValue ? true : false;
    });

    const getAcaoIntervencao = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_ACAO_INTERVENCAO}`, data)

    const getIndicadoresAcaoPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_INDICADORES_ACOES}`, data)

    const getExecucoesPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_EXECUCOES}`, data)
  const getDocumentosByAcaoIDs = async (data: any) =>
    await post<any, any>(`${GET_DOCUMENTO_BY_ACAO}` , data)
    const getDocumento = async (data: any) =>
      await get<any, any>(`${GET_DOCUMENTO}/` + data)
    const getShapeFileAcao = async (data: any) =>
    await post<any, any>(`${GET_INT_ACAO_SHAPEFILE}`, data)
    const getShapeFileIntervencao = async (data: any) =>
      await post<any, any>(`${GET_INT_INTERVENCOES_SHAPEFILE}`, data)
    const getShapeFileMobilizacao = async (data: any) =>
      await post<any, any>(`${GET_INT_MOBILIZACAO_SHAPEFILE}`, data)
    const getResumoExecucoesPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_RESUMO_EXECUCOES}`, data)

    const getAcaoPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_INT_ACAO}`, data)

    const relatorioAcaoMerge = async (data: any) =>
      await post<any, any>(`${RELATORIO_MERGE_ACAO}`, data)

    const getIntervencaoPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_INT_INTERVENCAO}`, data)

    const getCandidaturaPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_INT_CANDIDATURA}`, data)

    const getMobilizacaoAcoesPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_MOBILIZACAO_ACAO}`, data)

  const relatorioMobilizacaoMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_MOBILIZACAO}`, data)

    const getMobilizacoesPorIds = async (data: any) =>
      await post<any, any>(`${GET_LIST_RESULTS_INT_MOBILIZACAO}`, data)

  const relatorioIntervencaoMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_INTERVENCAO}`, data)

  const getPlaneamentoPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INT_PLANEAMENTO}`, data)

  const getIndicadoresPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INDICADORES}`, data)

  const getIntervencaoAcao = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INTERVENCAO_ACAO}`, data)

  const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

  const relatorioCandidaturaMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_CANDIDATURA}`, data)

  const INTERVENCAO = 0
  const ACAO = 1
  const CANDIDATURA = 2
  const MOBILIZACAO = 3
  const REGISTOS = 0
  const DOCUMENTOS = 1
  const handleSelect = (e: TabStripSelectEventArguments) => {
    if (e.selected == INTERVENCAO) {
        setNewRegistoLabel('Nova intervenção')
        SessionStorageService.setItem("moduloAtualIntervencao", "intervencao");

        if (!SessionStorageService.getItem('columnsIntervencao')) {
          setColumnsIntervencao(columsIntervencaoInicio)
        }
        setColumnsPrint(columnsIntervencaoGrid)
    } else if (e.selected == ACAO) {
        setNewRegistoLabel('Nova ação')
        SessionStorageService.setItem("moduloAtualIntervencao", "acao");

        if (!SessionStorageService.getItem("columnsAcao")) {
          setColumnsAcao(columnsAcaoOrdered)
        }
        setColumnsPrint(columnsAcaoGrid)
    } else if (e.selected == CANDIDATURA) {
        setNewRegistoLabel('Nova candidatura')
        SessionStorageService.setItem("moduloAtualIntervencao", "candidatura");

        if (!SessionStorageService.getItem("columnsCandidatura")) {
          setColumnsCandidatura(columnsCandidaturaOrdered)
        }
        setColumnsPrint(columnsCandidaturaGrid)
    } else if (e.selected === MOBILIZACAO) {
        setNewRegistoLabel('Nova mobilização')
        SessionStorageService.setItem("moduloAtualIntervencao", "mobilizacao");
        if (!SessionStorageService.getItem("columnsMobilizacao")) {
          setColumnsMobilizacao(columnsMobilizacaoOrdered)
        }
        setColumnsPrint(columnsMobilizacaoGrid)
    }
    setSelected(e.selected)
    SessionStorageService.setItem("selectedIntervencoesPai", e.selected);
  }

  useEffect(() => {
    switch(selected) {
      case INTERVENCAO :
        if (!SessionStorageService.getItem("columnsIntervencao")) {
          setColumnsIntervencao(columnsIntervencaoOrdered)
        }
        if (!SessionStorageService.getItem("columnsInterevencaoGrid")) {
          setColumnsIntervencaoGrid(columnsIntervencao);
        } else {
          setColumnsIntervencaoGrid(SessionStorageService.getItem("columnsInterevencaoGrid"));

        }
        setColumnsPrint(columnsIntervencaoGrid)
        setNewRegistoLabel('Nova Intervenção')
      break;
      case ACAO :
        if (!SessionStorageService.getItem("columnsAcao")) {
          setColumnsAcao(columnsAcaoOrdered);
        }
        if (!SessionStorageService.getItem("columnsAcaoGrid")) {
          setColumnsAcaoGrid(columsAcoesInicio)
        } else {
          setColumnsAcaoGrid(SessionStorageService.getItem("columnsAcaoGrid"));
        }
        setColumnsPrint(columnsAcaoGrid)
        setNewRegistoLabel('Nova ação')
      break;
      case CANDIDATURA:
        if (!SessionStorageService.getItem("columnsCandidatura")) {
          setColumnsCandidatura(columnsCandidaturaOrdered);
        }
        if (!SessionStorageService.getItem("columnsCandidaturaGrid")) {
          setColumnsCandidaturaGrid(columsCandidaturaInicio)
        }
        else {
          setColumnsCandidaturaGrid(SessionStorageService.getItem("columnsCandidaturaGrid"));
        }
        setColumnsPrint(columnsCandidaturaGrid)
        setNewRegistoLabel('Nova candidatura')
      break
      case MOBILIZACAO:
        if (!SessionStorageService.getItem("columnsMobilizacao")) {
          setColumnsMobilizacao(columnsMobilizacaoOrdered);
        }
        if (!SessionStorageService.getItem("columnsMobilizacaoGrid")) {
          setColumnsMobilizacaoGrid(columsMobilizacaoInicio)
        }
        else {
          setColumnsMobilizacaoGrid(SessionStorageService.getItem("columnsMobilizacaoGrid"));
        }
        setColumnsPrint(columnsMobilizacaoGrid)
        setNewRegistoLabel('Nova mobilização')
      break;
      default :
        setColumns(columnsIntervencaoOrdered)
        setColumnsPrint(columsIntervencaoInicio)
      break
    }
  }, [])

  useEffect(() => {
    SessionStorageService.setItem('selectedIntervencoesPai', selected);
  }, [selected]);

  useEffect(() => {
    SessionStorageService.setItem('showResultadoPesquisaIntervencao', showResultadoPesquisaIntervencao);
  }, [showResultadoPesquisaIntervencao])

  useEffect(() => {
    SessionStorageService.setItem("selectedAcao", selectedAcao);
  },[selectedAcao])

  useEffect(() => {
    SessionStorageService.setItem("selectedIntervencao", selectedIntervencao);
  },[selectedIntervencao])

  useEffect(() => {
    SessionStorageService.setItem("selectedCandidatura", selectedCandidatura);
  },[selectedCandidatura])

  useEffect(() => {
    SessionStorageService.setItem("selectedMobilizacao", selectedMobilizacao);
  },[selectedMobilizacao])



  const handleMessageEvent = useCallback((event: MessageEvent) => {
    if (event.data.type == "subSelectedIntervencaoChange") {
      const selectedValue = SessionStorageService.getItem("selectedIntervencoesPai");
      switch(selectedValue) {
        case ACAO :
          if (event.data.value == REGISTOS) {
            setColumnsPrint(columnsAcaoGrid)
            setShowExportButtons(true)
          }
          else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsAcaoGrid)
            setShowExportButtons(false)
          }
        break;
        case INTERVENCAO :
          if (event.data.value == REGISTOS) {
            setColumnsPrint(columnsIntervencaoGrid)
            setShowExportButtons(true)
          }
          else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsIntervencaoGrid)
            setShowExportButtons(false)
          }
        break;
        case CANDIDATURA :
          if (event.data.value == REGISTOS) {
            setColumnsPrint(columnsCandidaturaGrid)
            setShowExportButtons(true)
          }
          else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsCandidaturaGrid)
            setShowExportButtons(false)
          }
        break
      }
    }
    if (event.data.type == "clearSearchResultsIntervencao") {
      refreshSearchForm(INTERVENCAO)
    }
    if (event.data.type == "clearSearchResultsAcao") {
      refreshSearchForm(ACAO)
    }
    if (event.data.type == "clearSearchResultsCandidatura") {
      refreshSearchForm(CANDIDATURA)
    }
    if (event.data.type == "clearSearchResultsMobilizacao") {
      refreshSearchForm(MOBILIZACAO);
    }
    if (event.data.type == "columnsChangeIntervencao") {
      setColumnsIntervencao(event.data.value);
    }
    if (event.data.type == "columnsChangeAcao") {
      setColumnsAcao(event.data.value);
    }
    if (event.data.type == "columnsChangeCandidatura") {
      setColumnsCandidatura(event.data.value);
    }
    if (event.data.type == "columnsChangeMobilizacao") {
      setColumnsMobilizacao(event.data.value)
    }
 }, [])

  const refreshSearchForm = (tab: number) => {
    const previous = tab > 0 ? tab - 1 : tab + 1;
    handleSelect({selected: previous});
      setTimeout(() => {
        handleSelect({selected: tab});
      }, 1)
  }

  useEffect(() => {
    window.addEventListener('message', handleMessageEvent, false)

    return () => {
      window.removeEventListener('message', handleMessageEvent, false)
    }
  }, [handleMessageEvent])


  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'excel',
    },
    // {
    //   key: 'ExportarListaResultadosPdf',
    //   text: 'PDF'
    // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },

  ]

  const keyPainelPrincipalAcoes:Key = 'acaoColunasVisiveis';
  const keyPainelDocumentos:Key = 'acaoDocumentosColunasVisiveis';
  const [acoes, setacoes] = useState([])
  const [intervencoes, setIntervencoes] = useState([]);
  const [subSelected, setSubSelected] = useState(0)
  const canSeeIntervencao = hasPermission(PERMISSION_INTERVENCAO_PERFIL_BASICO) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);

  const canSeeCandidatura = hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
                            hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  useEffect(() => {
    if (canSeeIntervencao) {
      setSeeIntervencaoList(true);
    } else {
      setSeeIntervencaoList(false);
    }
    if (canSeeIntervencao) {
      setSeeAcao(true)
    } else {
      setSeeAcao(false);
    }
    if (canSeeIntervencao) {
      setSeeMobilizacao(true);
    } else {
      setSeeMobilizacao(false);
    }
    if (canSeeCandidatura) {
      setSeeCandidatura(true);
    } else {
      setSeeCandidatura(false);
    }
  }, []);

  const handleNewRegistoClick = useCallback(() => {
    if (selected === INTERVENCAO) {
      setCoordenadasPoligono(undefined)
      setIntervencaoSelected(undefined);
      selectIntervencaoResult(undefined);
      setShowResults(false)
      sessionStorage.setItem('novaIntervencao', 'true')

      SessionStorageService.removeItem("total_valor_execucao")
      SessionStorageService.removeItem("dataAcaoIntervencao");

      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setIntervencaoSelected({ utilizador_id: loggedUser?.user?.name })

      if (setShowRegistarIntervencao) setShowRegistarIntervencao(true)
    }
    if (selected === ACAO) {
      setAcaoSelected(undefined);
      setCoordenadasPoligono(undefined)
      selectAcaoResult(undefined);
      setShowResults(false)
      SessionStorageService.removeItem("dataAcaoExecucao")
      SessionStorageService.removeItem('valor_contratado')
      SessionStorageService.removeItem('revisao_precos')

      sessionStorage.setItem('novaAcao', 'true')

      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setAcaoSelected({ utilizador_id: loggedUser?.user?.username })

      if (setShowRegistarAcao) setShowRegistarAcao(true)
    }
    if (selected === CANDIDATURA) {
      setCandidaturaSelected(undefined);
      setCandidaturaAcaoSelected(undefined);
      selectCandidaturaResult(undefined);
      setShowResults(false)
      sessionStorage.setItem('novaCandidatura', 'true')

      if (setShowRegistarCandidatura) setShowRegistarCandidatura(true)
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setCandidaturaSelected({ utilizador_id: loggedUser?.user?.username })
    }
    if (selected === MOBILIZACAO) {
      setMobilizacaoSelected(undefined);
      selectMobilizacaoResult(undefined);
      setCoordenadasPoligono(undefined)

      SessionStorageService.setItem('mobilizacaoSubmetida', "false")
      SessionStorageService.setItem('mobilizacaoAntiga', "false")

      setShowResults(false)
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setMobilizacaoSelected({ utilizador_id: loggedUser?.user?.username })

      sessionStorage.setItem('novaMobilizacao', 'true')

      if (setShowRegistarMobilizacao) setShowRegistarMobilizacao(true)
    }
  }, [newRegistoLabel])

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {

        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

  };

  const optionsMais = [
    {
      key: 'novoRegisto',
      text: newRegistoLabel,
      elementType: 'button',
      className: 'icon-siarl icon-registar btnIconRegistar'
    }
  ]

  const options = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
  ]

  const removeSessionAcao = () => {
    sessionStorage.removeItem("lastSearchAcao")
  };

  const removeSessionCandidatura = () => {
    SessionStorageService.removeItem("lastSearchCandidatura")
  };

  const removeSessionMobilizacao= () => {
    sessionStorage.removeItem("lastSearchMobilizacao")
  };
  const {getVisibleColumns, removeColumnsKeys} = useVisibleColumns();

  const openAjuda = () => {
    window.open(URL_AJUDA_INTERVENCOES_INTERVENCAO)
  }

  const onItemClickExportarFichasAcao = async () => {
    try {


      const relatorios = [];

      const results =  SessionStorageService.getItem('resultadoAcaoPesquisa')

      const idsAcao = results.map((o: any) => o.id);

      if(idsAcao.length  > RECORDS_LIMIT){
        postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
        return false
      }
      const acoes = await getAcaoPorIds(idsAcao);
     const intervencaoAcao = await getAcaoIntervencao(idsAcao);
     const indicadoresAcao = await getIndicadoresAcaoPorIds(idsAcao);
     const execucoesAcao = await getExecucoesPorIds(idsAcao);
     const resumoExecucoesAcao = await getResumoExecucoesPorIds(idsAcao);


        postMessage({ type: 'showLoader' }, '*');

        for (const acaoId of idsAcao) {

        const acao = acoes.find((acao: any) => acao.id === acaoId);
        let ResultEntidade;
        if(acao?.utilizador?.id){

         ResultEntidade = await getEntidadeByUser(acao?.utilizador?.id)
        }
        const objToSendImgMapa : any = {
          CodPrintTemplate: "RELATORIO_INT_ACAO",
          extendInfo: {
            spatialReference: {
              wkid: 0
            },
            xmin: 0,
            ymin: 0,
            xmax: 0,
            ymax: 0
          },
          ListOperationalLayerInfo: [
            {
              IdOperationLayer: OPERATIONAL_LAYER,
              UseLayerExtent: false,
              DefinitionExpression: "",
              ListServiceLayer: [
                {
                    LayerId: LAYER_INDEX_INT_ACAO,
                    DefinitionExpression: "id=" + acao?.id,
                    UseLayerExtent: true
                }
              ]
            }
          ]
        }


      let formattedIntervencaoAcao;
      const filteredIntervencaoAcao = intervencaoAcao.filter((item: any) => item.id_acao === acaoId);
      if (filteredIntervencaoAcao.length > 0) {

        formattedIntervencaoAcao = filteredIntervencaoAcao.map((item: any) => ({
        'ID Intervencao': item.id_interv ?? '-',
        'Designacao': item.designacao ?? '-',
        'Código': item.codigo ?? '-',
        'Estado': item.intEstado?.descricao ?? '-',
        'Tipo n3': item.IntPalXXITipNivel3 ? item.IntPalXXITipNivel3.descricao : '-',
        'Percentagem': item.percentagem ?? '-',
      }));
}


    let formattedIndicadores;
    const filteredIndicadoresAcao = indicadoresAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredIndicadoresAcao.length > 0) {

      formattedIndicadores = filteredIndicadoresAcao.map((item: any) => ({
         'Indicador': item.intIndicador?.descricao ?? '-',
          'Valor': item.valor ?? '-'
    }));
    }

    let formattedAcaoExecucao;
    const filteredExecucoes = execucoesAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredExecucoes.length > 0) {

      formattedAcaoExecucao = filteredExecucoes.map((item: any) => ({
     'Data fatura': item?.data_fatura ? new Date(item.data_fatura).toLocaleString() : '-',
      'Numero fatura': item?.numero_fatura ?? '-',
      'Descricao': item?.descricao ?? '-',
      'Valor total': item?.valor_total ?? '-'
      }));
      }

    let formattedResumoExecucao;
    const filteredResumoExecucoes = resumoExecucoesAcao.filter((item: any) => item.id_acao === acaoId);
    if (filteredResumoExecucoes.length > 0) {

      formattedResumoExecucao = filteredResumoExecucoes.map((item: any) => ({
        'Ano': item?.ano ?? '-',
        'Numero registo': item?.numero_registos ?? '-',
        'Valor': item?.valor ?? '-'
    }));
    }


     const lstCandidaturaAcao = SessionStorageService.getItem("dataCandidaturaAcao");

       const formattedCandidaturaAcao = lstCandidaturaAcao?.map((item : any) => ({
        'ID Candidatura': item.id ?? '',
        'Entidade Comunitaria': item.intInstrumentoFinanciamento?.designacao ?? '',
        'Código': item.cod_candidatura ?? '',
        'Estado': item.intCandidaturaEstado?.descricao?? '',
        'Valor comunitário': item.inv_comp_total ?? '',
        'Valor nacional': item.inv_nacional_total ?? '',
        'Investimento previsto': item.inv_previsto_total ?? '',
   }));

    const lstMobilizacaoAcao = SessionStorageService.getItem("dataMobilizacaoAcao");

      const formattedMobilizacaoAcao = lstMobilizacaoAcao?.map((item : any) => ({
      'ID Mobilizacao': item.id ?? '',
      'Operação': item.tipo_mo?.descricao ?? '',
      'Data inicio': item.data_inicio ?? '',
      'Data fim': item.data_fim?? '',
      'Entidade': item.entidade?.nome ?? '',
      'Volume': item.volume_total ?? '',
      'Volume acao': item.volume_acao ?? '',
    }));


    const relatorio = {
      id: acao?.id,
      dados: {
            //  REGISTO
            'Nº processo APA:': acao?.n_filedoc ?? '',
            'Estado:': acao?.acaoEstado?.descricao ?? '',
            'Data/Hora Registo:': acao?.data_registo ? new Date(acao.data_registo).toISOString().split('T')[0].split('-').reverse().join('/') : '',
            'Técnico:': acao?.utilizador?.name ?? '',
            'Entidade:': ResultEntidade?.nome ?? '',

            //  IDENTIFICAÇÃO
            'Designação:': acao?.designacao ?? '',
            'Nº de processo aquisitivo:': acao?.n_processo_aquisitivo ?? '',
            'Procedimento de contratação:': acao?.id_proc_contratacao?.descricao ?? '',
            'Data da tutela:': acao?.data_tutela ?? '',
            'Data do tribunal de contas:': acao?.data_tc ?? '',
            'Data do artigo:': acao?.data_artigo ? new Date(acao?.data_artigo).toLocaleDateString() : '',
            'Data prevista início:': acao?.data_ini_p ?? '',
            'Data prevista conclusão:': acao?.data_con_p ?? '',
            'Investimento previsto:': acao?.inv_previs ?? '',
            'Data de adjudicação:': acao?.data_adjudicacao  ? new Date(acao?.data_adjudicacao).toLocaleDateString() : '',
            'Valor do contrato:': acao?.val_contrat ?? '',
            'Taxa de execução:': acao?.taxa_execucao ?? '',
            'Valor por executar:': acao?.valor_por_executar ?? '',
            'Investimento realizado:': acao?.inv_realizado ?? '',
            'Data de início de execução:': acao?.data_ini_e ?? '',
            'Data de conclusão de execução:': acao?.data_con_e ?? '',
            'Revisão preços:': acao?.revisao_precos ?? '',

            //  LOCALIZAÇÃO
            'Concelhos:': acao?.concelhos[0]?.nome ?? '',
            'ARH:': acao?.arhs[0]?.nome ?? '',
            'Capitania:': acao?.capitanias[0]?.nome ?? '',
            'Praia:': acao?.praia?.nome ?? '',
            'Referência do local:': acao?.local ?? '',

            'ENTIDADE REPONSÁVEL' : '',
            'Entidades:': acao?.diEntidade?.nome ?? '',

            'CARACTERIZAÇÃO' : '',
            'Tipologia nível 1:': acao?.tipo_n1?.descricao ?? '',
            'Tipologia nível 2:': acao?.tipo_n2?.descricao ?? '',
            'Tipologia nível 3:': acao?.tipo_n3?.descricao ?? '',
            'Tipologia nível 4:': acao?.tipo_n4?.descricao ?? '',
            'Natureza da ação:': acao?.acao_natureza?.descricao ?? '',
            'Componente da ação:': acao?.int_acao_componente?.descricao ?? '',
            'Tipo de planeamento:': acao?.int_acao_planeamento?.descricao ?? '',

            'FONTE FINANCEIRA' : '',
            'Nº de candidatura: ': acao?.numero_candidatura ?? '',
            'Designação de candidatura:': acao?.designacao_candidatura ?? '',

             //INTERVENCAO ACAO
             formattedIntervencaoAcao,

             //CANDIDATURAS ACAO
             formattedCandidaturaAcao,

             //CANDIDATURAS ACAO
             formattedMobilizacaoAcao,

            // //INDICADORES DE CONCRETIZACAO
            formattedIndicadores,

            // //EXECUCAO ACAO
            formattedAcaoExecucao,

            // //RESUMO EXECUCAO,
            formattedResumoExecucao
         },
        img_mapa: "",
        objJsonToCreateImg: objToSendImgMapa
    };


    relatorios.push(relatorio);
}

      const mergedPdfBase64 = await relatorioAcaoMerge(relatorios);
      if (mergedPdfBase64) {
        const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.log(error);
      postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
    } finally {
      postMessage({ type: 'hideLoader' }, '*');
    }
  };


const onItemClickExportarFichasCandidatura = async () => {
  try {


    const relatorios = [];

    const results = SessionStorageService.getItem('resultadoCandidaturaPesquisa');

    const idsCandidatura = results.map((o: any) => o.id);

    if(idsCandidatura.length  > RECORDS_LIMIT){
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
      return false
      }


    const candidaturas = await getCandidaturaPorIds(idsCandidatura);


      postMessage({ type: 'showLoader' }, '*');

      for (const candidaturaId of idsCandidatura) {

      const candidatura = candidaturas.find((candidatura: any) => candidatura.id === candidaturaId);
      const ResultEntidade = await getEntidadeByUser(candidatura?.utilizador?.id)


      const relatorio = {
        Id: candidatura.id,
        dados: {
          'REGISTO' : '',
          'Nº processo APA:': candidatura?.n_filedoc ?? '',
          'Estado:': candidatura?.intCandidaturaEstado?.descricao ?? '',
          'Data/Hora Registo:': candidatura?.data_hora_registo ? new Date(candidatura.data_hora_registo).toLocaleDateString(): '',
          'Técnico:': candidatura?.utilizador?.name ?? '',
          'Entidade:': ResultEntidade?.nome ?? '',

          'IDENTIFICACAO' : '',
          'Numero da candidatura:': candidatura?.cod_candid ?? '',
          'Investimento previsto:': candidatura?.inv_previsto_total ?? '',
          'Data registo:': candidatura?.data_registo ? new Date(candidatura.data_registo).toLocaleDateString() : '',
          'Investimento comunitario:': candidatura?.inv_comp_total ?? '',
          'Data de submissão:': candidatura?.data_submissao ? new Date(candidatura.data_submissao).toLocaleDateString() : '',
          'Investimento nacional:': candidatura?.inv_nacional_total ?? '',
          'Designação:': candidatura?.designacao ?? '',


          'Fonte de finaciamento:': candidatura?.tipo_incidencia?.descricao ?? '',
          'Instrumento de finaciamento:': candidatura?.intInstrumentoFinanciamento?.designacao ?? '',
          'Observacoes': candidatura?.obs ?? '',
        },

      };
      relatorios.push(relatorio);
  }

  const mergedPdfBase64 = await relatorioCandidaturaMerge(relatorios);
  if (mergedPdfBase64) {
    const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }
} catch (error) {
  console.log(error);
  postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
} finally {
  postMessage({ type: 'hideLoader' }, '*');
}
};


const onItemClickExportarFichasMobilizacao = async () => {
  try {


    const relatorios = [];

    const results = JSON.parse(
      SessionStorageService.getItem('resultadoMobilizacaoPesquisa') ?? ''
    );



    const idsMobilizacao = results.map((o: any) => o.id);

    if(idsMobilizacao.length  > RECORDS_LIMIT){
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
      return false
      }


    const mobilizacoes = await getMobilizacoesPorIds(idsMobilizacao);
    const mobilizacaoAcao = await getMobilizacaoAcoesPorIds(idsMobilizacao);



      postMessage({ type: 'showLoader' }, '*');

      for (const mobilizacaoId of idsMobilizacao) {

      const mobilizacao = mobilizacoes.find((mobilizacao: any) => mobilizacao.id === mobilizacaoId);
      let ResultEntidade;
      if(mobilizacao?.utilizador?.id){
       ResultEntidade = await getEntidadeByUser(mobilizacao?.utilizador?.id)
      }
      const objToSendImgMapa : any = {
        CodPrintTemplate: "RELATORIO_INT_MOBILIZACAO",
        extendInfo: {
          spatialReference: {
            wkid: 0
          },
          xmin: 0,
          ymin: 0,
          xmax: 0,
          ymax: 0
        },
        ListOperationalLayerInfo: [
          {
            IdOperationLayer: OPERATIONAL_LAYER,
            UseLayerExtent: false,
            DefinitionExpression: "",
            ListServiceLayer: [
              {
                  LayerId: LAYER_INDEX_INT_MOBILIZACAO,
                  DefinitionExpression: "id=" + mobilizacao?.id,
                  UseLayerExtent: true
              }
            ]
          }
        ]
      }

      let formattedAcaoMobilizacao;
    const filteredMobilizacaoAcao = mobilizacaoAcao.filter((item: any) => item.id_mobiliz === mobilizacaoId);
    if (filteredMobilizacaoAcao.length > 0) {
      formattedAcaoMobilizacao = filteredMobilizacaoAcao.map((item: any) => ({

      'ID acao': item?.id_acao ?? '',
      'Designacao' : item?.designacao ?? '',
      'Tipologia': item?.mobTipologia?.descricao ?? '',
      'Data conclusao': item?.data_conclusao ? new Date(item.data_conclusao).toLocaleString() : '-',
      'Data inicio': item?.data_inicio ? new Date(item.data_inicio).toLocaleString() : '-',
      'Volume': item?.volume === "" ? '' : item?.volume,
      'Localizacao': item?.localizacao ?? '',
      'entidade': item?.diEntidade?.nome ?? ''

    }));
}

      const relatorio = {
        id: mobilizacao?.id,
        dados: {
          //Registo
          'Nº processo APA:': mobilizacao?.filedoc_cod ?? '',
          'Estado:': mobilizacao?.int_mobilizacao_estado?.descricao ?? '',
          'Data/Hora Registo:': mobilizacao?.data_registo ? new Date(mobilizacao?.data_registo).toLocaleDateString() : '',
          'Técnico:': mobilizacao?.utilizador?.name ?? '',
          'Entidade registo:': ResultEntidade?.nome ?? '',


          //Identificação
          'Descricao:': mobilizacao?.descricao ?? '',
          'Operacao:': mobilizacao?.tipo_mo?.descricao ?? '',
          'Volume:': mobilizacao?.volume?.toString() ?? '',
          'Data de início:': mobilizacao?.data_inicio ? new Date(mobilizacao?.data_inicio).toLocaleDateString() : '',
          'Data de fím:': mobilizacao?.data_fim ? new Date(mobilizacao?.data_fim).toLocaleDateString() : '',
          'Entidade:': mobilizacao?.entidade?.nome ?? '',
          'Referencia:': mobilizacao?.referencia ?? '',


          //Localização
          'Concelhos:': mobilizacao?.concelhos[0]?.nome ?? '',
          'ARH:': mobilizacao?.arhs[0]?.nome ?? '',
          'Capitania:': mobilizacao?.capitanias[0]?.nome ?? '',
          'Praia:': mobilizacao?.praia?.nome ?? '',
          'Referência do local:': mobilizacao?.ref_localizacao ?? '',

          //tipologia
          'Objetivo da deposição nivel 1:': mobilizacao?.intMobObjetivoDeposicaoNivel1?.descricao ?? '',
          'Objetivo da deposição nivel 2:': mobilizacao?.intMobObjetivoDeposicaoNivel2?.descricao ?? '',
          'Método de execução:': mobilizacao?.mobMetodoDragagem?.descricao ?? '',
          'Tipo de mancha de emprestimo:': mobilizacao?.intMobMancEmprestimoNivel1?.descricao ?? '',

          'Observacoes:': mobilizacao?.observacoes ?? '',

          formattedAcaoMobilizacao

        },
        img_mapa: "",
        objJsonToCreateImg: objToSendImgMapa
      };


      relatorios.push(relatorio);
  }

    const mergedPdfBase64 = await relatorioMobilizacaoMerge(relatorios);
    if (mergedPdfBase64) {
      const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  } catch (error) {
    console.log(error);
    postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
  } finally {
    postMessage({ type: 'hideLoader' }, '*');
  }
};


  const onItemClickExportar = async(event: any) => {

    if (event.item.key == 'ExportarTodasFichas') {
      switch(selected) {

        case ACAO :
          onItemClickExportarFichasAcao();
        break
        case CANDIDATURA:
          onItemClickExportarFichasCandidatura();
          break
        case MOBILIZACAO :
        onItemClickExportarFichasMobilizacao();
        break
      }


    }
  else if (event.item.key == 'ExportarListaResultadosExcel') {
  const moduloAtual = SessionStorageService.getItem("moduloAtualIntervencao");

  if (moduloAtual === "intervencao" || !moduloAtual) {
    const objToSearch = SessionStorageService.getItem("lastSearchIntervencao");
    const lstListagem = await consultarIntervencaoToExport(objToSearch);
    const ids = lstListagem.map((x: any) => x.id);
    const lstAssociacoesAcao = await consultarIntAcaoAssociada(ids);
    const lstEntidadesAssociadas = await getEntidadesAssociadasToExport(ids);
    const lstPlaneamentos = await getPlaneamentosByIdsIntervencoes(ids);
    const lstIndicadores = await getIndicadoresByIdsIntervencoes(ids);
    const lstFontesFinanciamento = await getIntFontesFinanciamentosToExport(ids);
    exportToExcelWithTabsIntervencao(
      lstListagem, "Intervenções",
      lstAssociacoesAcao, "Ações",
      "Intervencoes",
      lstFontesFinanciamento, "Fontes Financiamento",
      lstEntidadesAssociadas, "Entidades",
      lstPlaneamentos, "Inst. Planeamento",
      lstIndicadores, "Int. Indicadores"
    );
  }
  else if (moduloAtual === "acao") {
    const objToSearch = SessionStorageService.getItem("lastSearchAcao");
    const lstListagem = await consultarAcao(objToSearch);
    const ids = lstListagem.map((x: any) => x.id);

    const lstAcoes = await getAcaoToExport(ids);
    const lstIntervencaoAssociada = await consultarAcaoIntervencaoAssociada(ids);
    const lstEntidadesAssociadas = await getEntidadesAssociadasAcaoToExport(ids);
    const lstMobilizacaoAcao = await getMobilizacaoAcaoToExport(ids)
    const lstAcaoExecucao = await getExecucoesAcaoToExport(ids)
    const lstCandidaturaAcao = await getCandidaturasAcaoToExport(ids)
    const lstComponentesAcao = await getAcaoComponentesToExport(ids)
    const lstResumoExecucoes = await getResumoExecucoesAcaoToExport(ids)
    const lstFontesFinanciamento = await getAcaoFonteFinanciamentoToExport(ids)
  
  exportToExcelWithTabsIntervencao(
        lstAcoes, "Ações",
        lstIntervencaoAssociada, "Intervenções",
        "Ações",
        lstEntidadesAssociadas, "Entidades",
        lstMobilizacaoAcao, "Mobilização",
        lstCandidaturaAcao, "Candidaturas",
        lstFontesFinanciamento, "Financiamento Nacional",
        lstComponentesAcao, "Componentes",
        lstAcaoExecucao, "Execuções",
        lstResumoExecucoes, "ResumoExecuções"
      );

    }
  else if (moduloAtual === "candidatura") {
   const objToSearch = SessionStorageService.getItem("lastSearchCandidatura");
    const lstListagem = await consultarCandidatura(objToSearch);
    const ids = lstListagem.map((x: any) => x.id);

    const lstCandidaturas = await getCandidaturaToExport(ids);
    const lstAcaoCandidatura = await getAcaoCandidaturaToExport(ids);
  
    exportToExcelWithTabsIntervencao(
          lstCandidaturas, "Candidaturas",
          lstAcaoCandidatura, "Ações",
          "Candidaturas",
        );

  }
  else if (moduloAtual === "mobilizacao") {
   const objToSearch = SessionStorageService.getItem("lastSearchMobilizacao");
    const lstListagem = await consultarMobilizacao(objToSearch);
    const ids = lstListagem.map((x: any) => x.id);

    const lstMobilizacao = await getMobilizacaoToExport(ids);
    const lstAcaoMobilizacao = await getAcaoMobilizacaoToExport(ids);
  
    exportToExcelWithTabsIntervencao(
          lstMobilizacao, "Mobilizações",
          lstAcaoMobilizacao, "Ações",
          "Mobilizações",
        );  }
  }else if (event.item.key == 'ExportarListaResultadosPdf') {

      exportPDF();

    } else if (event.item.key == "ExportarListaResultadosShapeFile") {

      let results;
      let name;
      if (selected == INTERVENCAO) {
        results = SessionStorageService.getItem("resultadoIntervencaoPesquisa");
        name = "shapeFileIntInterevencao.zip"
      } else if (selected == ACAO) {
        results = SessionStorageService.getItem('resultadoAcaoPesquisa');
        name =  'shapeFileIntAcao.zip'
      } else if (selected == MOBILIZACAO) {
        results = JSON.parse(SessionStorageService.getItem("resultadoMobilizacaoPesquisa") ?? '');
        name = "shapeFileIntMobilizacao.zip"
      }

      if (results) {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        let file: any;
        if (selected == ACAO) {
          file = await getShapeFileAcao(ids);
        }
        else if (selected == INTERVENCAO) {
          file = await getShapeFileIntervencao(ids);
        }
        else if (selected == MOBILIZACAO) {
          file = await getShapeFileMobilizacao(ids);
        }
        const filePath = name;

        handleDownload(file, filePath);
      }

  }
};
const exportExcel = () => {
  _export.save();
};


const exportPDF = () => {
  _exportPdf.save();
};
const onItemClickImprimir = async (event: any) => {
  exportPDF();
}

const openPdfNewTab = () => {
  return new Promise<void>((resolve, reject) => {

      postMessage({ type: "showLoader" }, "*");

      setTimeout(() => {
         let columnsToShow: any;
         let results;
        if (selected == ACAO) {
          columnsToShow = columnsAcaoGrid.columns.filter((x: any) => x.show);
          results = SessionStorageService.getItem("resultadoAcaoPesquisa");
        }
        else if (selected == INTERVENCAO) {
          columnsToShow = columnsIntervencaoGrid.columns.filter((x: any) => x.show);
          results = SessionStorageService.getItem("resultadoIntervencaoPesquisa");
        }
        else if (selected == CANDIDATURA) {
          columnsToShow = columnsCandidaturaGrid.columns.filter((x: any) => x.show);
          results = JSON.parse(SessionStorageService.getItem("resultadoCandidaturaPesquisa") ?? '');
        }
        else if (selected == MOBILIZACAO) {
          columnsToShow = columnsMobilizacaoGrid.columns.filter((x: any) => x.show);
          results = JSON.parse(SessionStorageService.getItem("resultadoMobilizacaoPesquisa") ?? '');
        }

        const dataToExport = results?.map((item: any) => {
          const filteredItem: any = {};
          columnsToShow.forEach((column: any) => {
              if (column.field.indexOf(".") != -1) {
                const textArr = column.field.split(".");
                const fieldString = textArr[0];
                const valueString = textArr[1];
                if (valueString) {
                  filteredItem[column.field] = item[fieldString][valueString];
                }
              } else {
              filteredItem[column.field] = item[column.field];
            }
          });
          return filteredItem;
      });

          exportPDFWithMethod(columnsToShow, dataToExport, 8)
              .then((pdfData: any) => {
                  postMessage({ type: "hideLoader" }, "*");

                      const base64Data = pdfData.split(";base64,")[1];
                      console.log(base64Data);
                      const blob = b64toBlob(base64Data, 'application/pdf');
                      const blobUrl = URL.createObjectURL(blob);


                      window.open(blobUrl, '_blank');
                      resolve();

              })
              .catch((error: any) => {
                  console.error('Error exporting PDF:', error);
                  reject(error);
              });
      }, 1000);
  });
};

  const onItemClickImprimirAcao = (event: any) => {

    const link: HTMLAnchorElement | null = document.querySelector('#print-results-acao');

    if (link) {
      link.click();
    }
  };

  const onItemClickImprimirDocumentos = (event: any) => {

    if (event.item.key == 'ExportarListaResultados') {

      const link: HTMLAnchorElement | null = document.querySelector('#print-results-documentos');

      if (link) {
        link.click();
      }

    }

  };

  const setResultsAcao = () => {
    const results =  SessionStorageService.getItem('resultadoAcaoPesquisa')
    setacoes(results)
    const iframe: any = document.getElementById('iframeGeoPortal')
    const ids: any[] = []
    results.forEach((item: any) => {
      ids.push(item.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlIntAcaoSearch', value: ids },
        '*'
      )

    postMessage({ type: 'hideLoader' }, '*');

}

  const ColumnMenu = (dataState: any) => {
    const results =  SessionStorageService.getItem('resultadoIntervencaoPesquisa')
      const datafilter = results;
      return (
        <div>

        <GridColumnMenuCheckboxFilter {...dataState} data={datafilter} expanded={true} />
      </div>)

    }

const [columsDocumentsAcao, setColumsDocumentsAcao] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
  columns: [
    { field: "id", width: 70, title: "ID", show: true },
    { field: "acao_id", width: 190, title: "ID Ação", show: true },
    { field: "data_publicacao", width: 150, title: "Data publicação", show: true },
    { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
    { field: "titulo", width: 90, title: "Título", show: true },
    { field: "autores", width: 90, title: "Autor", show: true },
    { field: "entidade.nome", width: 190, title: "Entidade", show: true },
    { field: "primarioDescription", width: 180, title: "Primário", show: true },
  ]
})

const [columsDocumentsCandidatura, setColumsDocumentsCandidatura] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
  columns: [
    { field: "id", width: 70, title: "ID", show: true },
    { field: "candidatura_id", width: 190, title: "ID Candidatura", show: true },
    { field: "data_publicacao", width: 150, title: "Data publicação", show: true },
    { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
    { field: "titulo", width: 90, title: "Título", show: true },
    { field: "autores", width: 90, title: "Autor", show: true },
    { field: "entidade.nome", width: 90, title: "Entidade", show: true },
    { field: "primarioDescription", width: 180, title: "Primário", show: true },
  ]
})

const [columsDocumentsMobilizacao, setColumsDocumentsMobilizacao] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
  columns: [
    { field: "id", width: 70, title: "ID", show: true },
    { field: "mobilizacao_id", width: 190, title: "ID Mobilização", show: true },
    { field: "data_publicacao", width: 150, title: "Data publicação", show: true },
    { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
    { field: "titulo", width: 90, title: "Título", show: true },
    { field: "autores", width: 90, title: "Autor", show: true },
    { field: "entidade.nome", width: 90, title: "Entidade", show: true },
    { field: "primarioDescription", width: 180, title: "Primário", show: true },
  ]
})

const [columsAcoesInicio, setColumsAcoesInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
  columns:[
    { field: "id", title: "ID", show: true,width:70 },
    { field: "tipo_n4.descricao", title: "Tipologia Nível 4 (Execução)", show: true,width: 250 },
    { field: "designacao", title: "Designação", show: true,width: 190  },
    { field: "componenteAcaoConcatenada", title: "Componentes da ação", show: true,width: 220 },
    { field: "val_contrat", title: "Preço contratual", show: true,width:190},
    { field: "data_ini_e", title: "Data início de execução", show: true,width: 230  },
    { field: "data_con_e", title: "Data conclusão de execução", show: true,width: 230  },
    { field: "entidades", title: "Entidade", show: true,width:190 },
    { field: "acaoEstado.descricao", title: "Estado", show: true,width: 160  },
    { field: "tipo_n1.descricao", title: "Tipologia Nível 1 (PAL XXI)", show: false,width: 250  },
    { field: "tipo_n2.descricao", title: "Tipologia Nível 2 (PAL XXI)", show: false,width: 250  },
    { field: "tipo_n3.descricao", title: "Tipologia Nível 3 (PAL XXI)", show: false,width: 250  },
    { field: "acaoTipEngenharia.descricao", title: "Tipo de engenharia", show: false,width: 250  },
    { field: "int_acao_planeamento.descricao", title: "Tipo de planeamento", show: false,width: 250  },
    { field: "acao_natureza.descricao", title: "Natureza da ação", show: false,width: 180 },
    { field: "proc_contratacao.descricao", title: "Procedimento de contratação", show: false,width: 250  },
    { field: "data_ini_p", title: "Data início prevista", show: false,width: 230  },
    { field: "data_con_p", title: "Data conclusão prevista", show: false,width: 230  },
    { field: "inv_previs", title: "Investimento Previsto", show: false,width:200 },
    { field: "data_adjudicacao", title: "Data de adjudicação", show: false,width:190 },
    { field: "revisao_precos", title: "Revisão de preços", show: false,width:190 },
    { field: "inv_realizado", title: "Valor realizado", show: false,width:190 },
    { field: "distritos", title: "Distrito", show: false, width: 190 },
    { field: "concelhos", title: "Concelho", show: false, width: 190 },
    { field: "freguesias", title: "Freguesia", show: false, width: 190 },
    { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
    { field: "arhs", title: "ARH", show: false, width: 190 },
    { field: "capitanias", title: "Capitania", show: false, width: 190 },
    { field: "nuts1", title: "NUTS I", show: false, width: 190 },
    { field: "nuts2", title: "NUTS II", show: false, width: 190 },
    { field: "nuts3", title: "NUTS III", show: false, width: 190 },
  ]
})


const [columsIntervencaoInicio, setColumsIntervencaInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean, columnMenu?:any,}[]}>({

  columns : [
    { field: "id", title: "ID", show: true,width:70 },
  // { field: "instrumento", title: "Instrumento", show: true, width:130 },
  { field: "designacao", title: "Designação", show: true,width:170 , columnMenu: ColumnMenu,},
  { field: "int_prioridade.descricao", title: "Prioridade", show: true,width:170, columnMenu: ColumnMenu, },
  { field: "objetivo", title: "Objetivo", show: false,width:238 ,columnMenu: ColumnMenu, },
  { field: "inv_global", title: "Investimento global", show: true,width:238 ,columnMenu: ColumnMenu, },
  { field: "val_executado", title: "Valor executado", show: true,width:238  ,columnMenu: ColumnMenu,},
  { field: "fin_nacional", title: "Financiamento nacional", show: false,width:238  ,columnMenu: ColumnMenu, },
  { field: "fin_comunitario", title: "Financiamento comunitário", show: false,width:238 , columnMenu: ColumnMenu, },
  { field: "inicio", title: "Início", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "fim", title:  "Conclusão", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "filedoc_cod", title:  "Nº Processo APA", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "data_registo", title:  "Data de registo", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "numero_intervencao", title:  "Código da intervenção", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "fonteFinanciamento", title:  "Fonte de financiamento previsto", show: false,width: 120 ,columnMenu: ColumnMenu,  },
  { field: "tipoIntervencao", title:  "Tipo de intervenção", show: false,width: 120 , columnMenu: ColumnMenu, },
  { field: "int_pal_xxi_tip_nivel_1.descricao", title: "Tipologia Nível 1 (PAL XXI)", columnMenu: ColumnMenu, show: false,width: 250 },
  { field: "int_pal_xxi_tip_nivel_2.descricao", title: "Tipologia Nível 2 (PAL XXI)", show: false,width:250 , columnMenu: ColumnMenu,},
  { field: "int_pal_xxi_tip_nivel_3.descricao", title: "Tipologia Nível 3 (PAL XXI)", show: true,width:250 , columnMenu: ColumnMenu, },
  { field: "estado.descricao", title: "Estado", show: true,width: 140 , columnMenu: ColumnMenu, },
  { field: "entidades", title: "Entidades", show: true,width:238 , columnMenu: ColumnMenu, },
  { field: "localizacao", title: "Local", show: true,width:238 , columnMenu: ColumnMenu, },
  { field: "distritos", title: "Distrito", show: false, width: 190 , columnMenu: ColumnMenu,},
  { field: "concelhos", title: "Concelho", show: false, width: 190 , columnMenu: ColumnMenu, },
  { field: "freguesias", title: "Freguesia", show: false, width: 190 , columnMenu: ColumnMenu, },
  { field: "massasAgua", title: "Massa de água", show: false, width: 190 ,columnMenu: ColumnMenu,},
  { field: "arhs", title: "ARH", show: false, width: 190 , columnMenu: ColumnMenu, },
  { field: "capitanias", title: "Capitania", show: false, width: 190 ,columnMenu: ColumnMenu, },
  { field: "nuts1", title: "NUTS I", show: false, width: 190 ,columnMenu: ColumnMenu,},
  { field: "nuts2", title: "NUTS II", show: false, width: 190 , columnMenu: ColumnMenu,},
  { field: "nuts3", title: "NUTS III", show: false, width: 190 , columnMenu: ColumnMenu,},
]
})


const [columsCandidaturaInicio, setColumsCandidaturaInicio] = useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
  columns:[
    { field: "id", title: "ID", show: true, width: 70 },
    { field: "designacao", title: "Designação", show: true, width: 170 },
    { field: "cod_candid", title: "Nº de Candidatura", show: false, width: 180 },
    { field: "valor_candid", title: "Valor Candidatura", show: false, width: 190 },
    { field: "valor_comp", title: "Valor Compartipação", show: false, width: 190 },
    { field: "valor_total", title: "Valor Total", show: true, width: 190 },
    { field: "despesa_elegivel", title: "Despesa Elegível", show: true, width: 190 },
    { field: "despesa_nao_elegivel", title: "Despesa Não Elegível", show: true, width: 190 },
    { field: "intCandidaturaEstado.descricao", title: "Estado", show: true, width: 170 },
    { field: "tipo_incidencia.descricao", title: "Tipo de Incidência", show: false, width: 190 },
    { field: "utilizador.name", title: "Técnico de registo", show: false, width: 190 },
    { field: "intInstrumentoFinanciamento.designacao", title: "Instrumento de Financiamento", show: true, width: 250 },
  ]
});


const [columsMobilizacaoInicio, setColumsMobilizacaoInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
  columns:[
    { field: "id", title: "ID", show: true,width:70 },
    { field: "tipo_mo.descricao", title: "Tipologia de mobilização", show: true,width: 240 },
    { field: "entidade.nome", title: "Entidade", show: true,width: 200 },
    { field: "referencia", title: "Referência", show: true,width: 200 },
    { field: "ref_localizacao", title: "Localização", show: true,width: 200 },
    { field: "volume", width: 170, title: "Volume em m³", show: true },
    { field: "int_mobilizacao_estado.descricao", title: "Estado", show: true,width: 180 },
    { field: "descricao", title: "Designação", show: false,width: 180 },
    { field: "utilizador.name", title: "Técnico de registo", show: false,width: 200 },
    { field: "distritos", title: "Distrito", show: false, width: 190 },
    { field: "concelhos", title: "Concelho", show: false, width: 190 },
    { field: "freguesias", title: "Freguesia", show: false, width: 190 },
    { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
    { field: "arhs", title: "ARH", show: false, width: 190 },
    { field: "capitanias", title: "Capitania", show: false, width: 190 },
    { field: "nuts1", title: "NUTS I", show: false, width: 190 },
    { field: "nuts2", title: "NUTS II", show: false, width: 190 },
    { field: "nuts3", title: "NUTS III", show: false, width: 190 },
    { field: "filedoc_cod", title: "Nº Processo APA", show: false, width: 190 },
    { field: "data_inicio", title: "Data de início", show: false, width: 190 },
    { field: "data_fim", title: "Data de conclusão", show: false, width: 190 },
    { field: "tipo_mob_objetivo_dep_1_id", title: "Objetivo nivel 1", show: false, width: 190 },
    { field: "tipo_mob_objetivo_dep_2_id", title: "Objetivo nivel 2", show: false, width: 190 },
    // { field: "int_mobilizacao_funcao.descricao", title: "Função", show: true,width: 180 },
  ]
})
const columnsIntervencaoOrdered = {columns: columsIntervencaoInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))}
const columnsAcaoOrdered =  {columns: columsAcoesInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))}
const columnsMobilizacaoOrdered =  {columns: columsMobilizacaoInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))}
const columnsCandidaturaOrdered =  {columns: columsCandidaturaInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))}


const [columns, setColumns] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsIntTabs');
  return storedValue ??  columnsIntervencaoOrdered;
});


const [columnsGrid, setColumnsGrid] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsIntervencaoGrid');
  return storedValue ?? columsIntervencaoInicio;
});

const [columnsAcaoGrid, setColumnsAcaoGrid] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsAcaoGrid');
  return storedValue ?? columsAcoesInicio;
});


const [columsDocumentsIntervencoes, setColumsDocumentsIntervencoes] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsDocumentsIntervencao');
  return storedValue ?? {
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "intervencao_id", width: 190, title: "ID intervenção", show: true },
      { field: "data_publicacao", width: 150, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 90, title: "Título", show: true },
      { field: "autores", width: 90, title: "Autor", show: true },
      { field: "entidade.nome", width: 90, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  };
});

useEffect(() => {
  SessionStorageService.setItem("columnsDocumentsIntervencao", columsDocumentsIntervencoes)
}, [columsDocumentsIntervencoes])

const [columnsIntervencao, setColumnsIntervencao] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsIntervencao');
  return storedValue ?? columnsIntervencaoOrdered;
});

const [columnsIntervencaoGrid, setColumnsIntervencaoGrid] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsIntervencaoGrid');
  return storedValue ?? columsIntervencaoInicio;
});

const [columnsMobilizacaoGrid, setColumnsMobilizacaoGrid] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsMobilizacaoGrid');
  return storedValue ?? columsMobilizacaoInicio;
});

useEffect(() => {
  SessionStorageService.setItem("columnsIntTabs", columns)
}, [columns])

useEffect(() => {
  SessionStorageService.setItem("columnsIntervencaoGrid", columnsIntervencaoGrid)
}, [columnsIntervencaoGrid])

useEffect(() => {
  SessionStorageService.setItem("columnsAcaoGrid", columnsAcaoGrid)
}, [columnsAcaoGrid])

useEffect(() => {
  SessionStorageService.setItem("columnsMobilizacaoGrid", columnsMobilizacaoGrid)
}, [columnsMobilizacaoGrid])

useEffect(() => {
  SessionStorageService.setItem("columnsIntervencao", columnsIntervencao)
  updateColumnsGrid(columnsIntervencao, columnsIntervencaoGrid, setColumnsIntervencaoGrid)
}, [columnsIntervencao])

const [columnsAcao, setColumnsAcao] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsAcao');
  return storedValue ?? columnsAcaoOrdered;
});


useEffect(() => {
  SessionStorageService.setItem("columnsAcao", columnsAcao)
  updateColumnsGrid(columnsAcao, columnsAcaoGrid, setColumnsAcaoGrid)
}, [columnsAcao])

const [columnsCandidatura, setColumnsCandidatura] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsCandidatura');
  return storedValue ?? columnsCandidaturaOrdered;
});

const [columnsCandidaturaGrid, setColumnsCandidaturaGrid] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsCandidaturaGrid');
  return storedValue ?? columsCandidaturaInicio;
});

const [columnsMobilizacao, setColumnsMobilizacao] =  useState<any>(() => {
  const storedValue = SessionStorageService.getItem('columnsMobilizacao');
  return storedValue ?? columnsMobilizacaoOrdered;
});

useEffect(() => {
  SessionStorageService.setItem("columnsCandidaturaGrid", columnsCandidaturaGrid)
}, [columnsCandidaturaGrid])

useEffect(() => {
  SessionStorageService.setItem("columnsCandidatura", columnsCandidatura)
  updateColumnsGrid(columnsCandidatura, columnsCandidaturaGrid, setColumnsCandidaturaGrid)
}, [columnsCandidatura])

useEffect(() => {
  SessionStorageService.setItem("columnsMobilizacao", columnsMobilizacao)
  updateColumnsGrid(columnsMobilizacao, columnsMobilizacaoGrid, setColumnsMobilizacaoGrid)
}, [columnsMobilizacao])


const itemRender = (props: { item: any; itemIndex: number }) => {
  const isTitleItem = props.item.key === 'titulo';
  if (isTitleItem) {
    // Item de título personalizado
    return (
      <div className={styles.DropDownButtonTitulo}>
        <span>{props.item.text}</span>
      </div>
    );
  } else {
    // Demais itens
    return (
      <div className={styles.DropDownButtonItem}>
        <span>{props.item.text}</span>
      </div>
    );
  }
};

const resultadosPesquisas = (selected === 0 && SessionStorageService.getItem("resultadoIntervencaoPesquisa")) || (selected === 1 && SessionStorageService.getItem("resultadoAcaoPesquisa")) || (selected === 2 && SessionStorageService.getItem("resultadoCandidaturaPesquisa")) || (selected === 2 && SessionStorageService.getItem("resultadoMobilizacaoPesquisa"));

  return (
    <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
      <div className={styles.header}>
        <div>
          <div className={styles.nomeDoModulo}>Intervenções</div>
          <div className={styles.tituloDaPagina}>Critérios de pesquisa</div>
        </div>

        <div>

          {(
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
              hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL)
              )?
          <Button
            onClick={handleNewRegistoClick}
            className={styles.btnNovoRegisto}
            style={{ display: isMobile ? 'none' : '' }}
            id='novoRegisto'
            title={newRegistoLabel}
          >
            <span className="icon-siarl icon-registar btnIconRegistar" /> &nbsp;{' '}
            {newRegistoLabel}
          </Button>
            :  ''}

          {(!isMobile && selected == ACAO && showExportButtons && SessionStorageService.getItem("resultadoAcaoPesquisa")) &&
          <><VisualizadorColunas
              columns={columnsAcao}
              setColumns={setColumnsAcao}
              styles={styles.btnEditar2} />

              <button className={styles.btnEditar2} onClick={exportPDF} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
                <span className="icon-siarl icon-imprimir"></span>
              </button><DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                title='Exportar'
                itemRender={itemRender}
              ></DropDownButton></>
          }
          {(!isMobile && selected == INTERVENCAO && showExportButtons  && SessionStorageService.getItem("resultadoIntervencaoPesquisa")) &&
          <><VisualizadorColunas
              columns={columnsIntervencao}
              setColumns={setColumnsIntervencao}
              styles={styles.btnEditar2} />

              <button className={styles.btnEditar2} onClick={exportPDF} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
                <span className="icon-siarl icon-imprimir"></span>
              </button><DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                title='Exportar'
                itemRender={itemRender}
              ></DropDownButton></>
          }

        {(!isMobile && selected == CANDIDATURA && showExportButtons  && SessionStorageService.getItem("resultadoCandidaturaPesquisa")) &&
          <><VisualizadorColunas
              columns={columnsCandidatura}
              setColumns={setColumnsCandidatura}
              styles={styles.btnEditar2} />

              <button className={styles.btnEditar2} onClick={exportPDF} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
                <span className="icon-siarl icon-imprimir"></span>
              </button><DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                title='Exportar'
                itemRender={itemRender}
              ></DropDownButton></>
          }

        {(!isMobile && selected == MOBILIZACAO && showExportButtons && SessionStorageService.getItem("resultadoMobilizacaoPesquisa")) &&
          <><VisualizadorColunas
              columns={columnsMobilizacao}
              setColumns={setColumnsMobilizacao}
              styles={styles.btnEditar2} />

              <DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                title='Exportar'
                itemRender={itemRender}
              ></DropDownButton></>
          }

          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
            <span className="icon-siarl icon-ajuda" />
          </button>

          <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
            <span className="icon-siarl icon-minimizar" />
          </button>

          {!isMobile && resultadosPesquisas ? (
            <MaximizeButton className={styles.btnMaximizar} />
          ) : ''}
        </div>
      </div>
      <TabStrip selected={selected} onSelect={handleSelect}
      scrollable={isMobile}>
        {canSeeIntervencao || seeIntervencaoList ?
        <TabStripTab title="Intervenções" key="Intervenções">
          {SessionStorageService.getItem("resultadoIntervencaoPesquisa") ?
            <ResultadoIntervencaoForm  columns={columnsIntervencaoGrid} setColumns={setColumnsIntervencaoGrid} columnsDocuments={columsDocumentsIntervencoes} setColumnsDocuments={setColumsDocumentsIntervencoes} setShowResultadoIntervencao={setShowResults} setShowRegistarIntervencao={setShowRegistarIntervencao}></ResultadoIntervencaoForm>
          :
            <PesquisarIntervencao onCloseClick={onCloseClick} />
          }
        </TabStripTab>
         : ''}
         {canSeeIntervencao || seeAcao  ?
        <TabStripTab title="Ações" key="Ação">
          {SessionStorageService.getItem("resultadoAcaoPesquisa") ?
            <ResultadoAcaoForm columns={columnsAcaoGrid} setColumns={setColumnsAcaoGrid} columnsPrint={columnsPrint} setColumnsPrint={setColumnsPrint} columnsDocuments={columsDocumentsAcao} setColumnsDocuments={columsDocumentsAcao}  setShowResultadoAcao={setShowResultadoAcao} onCloseClick={onCloseClick} setShowRegistarAcao={setShowRegistarAcao}></ResultadoAcaoForm>
          : <PesquisarAcao onClick={removeSessionAcao} onCloseClick={onCloseClick} /> }
        </TabStripTab>
        : ''}
        {canSeeCandidatura || seeCandidatura ?
        <TabStripTab title="Candidaturas" key="Candidatura">
          {SessionStorageService.getItem("resultadoCandidaturaPesquisa") ?
            <ResultadoCandidaturaForm columns={columnsCandidaturaGrid} setColumns={setColumnsCandidaturaGrid} columnsDocuments={columsDocumentsCandidatura} setColumnsDocuments={setColumsDocumentsCandidatura} setShowResultadoCandidatura={setShowResultadoCandidatura} setShowRegistarCandidatura={setShowRegistarCandidatura} ></ResultadoCandidaturaForm>
          :
            <PesquisarCandidatura onClick={removeSessionCandidatura} onCloseClick={onCloseClick} />
          }
        </TabStripTab>
        : ''}
        {canSeeIntervencao || seeMobilizacao ?
        <TabStripTab title="Mobilizações" key="Mobilização">
          {SessionStorageService.getItem("resultadoMobilizacaoPesquisa") ?
          <ResultadoMobilizacaoForm columns={columnsMobilizacaoGrid} setColumns={setColumnsMobilizacaoGrid} setShowResultadoMobilizacao={setShowResultadoMobilizacao} setShowRegistarMobilizacao={setShowRegistarMobilizacao}></ResultadoMobilizacaoForm>
              :
          <PesquisarMobilizacao onClick={removeSessionMobilizacao} onCloseClick={onCloseClick} />
          }
        </TabStripTab>
        : ''}
      </TabStrip>
    </div>
  )
}
